import StatCard from "../components/StatCard";
import StatusBadge from "../components/StatusBadge";

function DashboardPage({
  username = "",
  description = "",
  stats = [],
  activeLeagues = [],
  upcomingMatches = [],
  teamSummary = null,
  notifications = [],
  onOpenLeague,
  onOpenMatch,
  onOpenTeam,
}) {
  return (
    <section className="appRoutePage dashboardRoutePage commandRoutePage">
      <div className="dashboardRouteHero">
        <div>
          <h1>Command Center</h1>
          <p>{description || `Manage your team and track your competitive journey${username ? `, ${username}` : ""}.`}</p>
        </div>
      </div>

      <div className="dashboardRouteStats">
        {stats.map((stat) => (
          <StatCard
            key={stat.label}
            label={stat.label}
            value={stat.value}
            note={stat.note}
            icon={stat.icon}
            trend={stat.trend}
            trendPositive={stat.trendPositive}
            tone={stat.tone || "blue"}
            onClick={stat.onClick}
          />
        ))}
      </div>

      <div className="dashboardRouteLayout">
        <div className="dashboardRoutePrimary">
          <div className="dashboardSectionHeader">
            <h2>Active Leagues</h2>
            <button type="button" className="dashboardInlineLink" onClick={() => onOpenLeague?.()}>
              View All
              <span aria-hidden="true">{"\u2192"}</span>
            </button>
          </div>

          <div className="dashboardLeagueList">
            {activeLeagues.length > 0 ? (
              activeLeagues.map((league) => (
                <button
                  key={`dashboard-league-${league.id}`}
                  type="button"
                  className="dashboardLeagueCard"
                  onClick={() => onOpenLeague?.(league)}
                >
                  <div className="dashboardLeagueCardHead">
                    <div className="dashboardLeagueMark" aria-hidden="true">{"\u2655"}</div>
                    <div className="dashboardLeagueCopy">
                      <strong>{league.name}</strong>
                      <span>{league.subtitle}</span>
                    </div>
                    <div className="dashboardLeagueState">
                      {league.isLive ? <span className="dashboardLiveDot">Live</span> : null}
                      <StatusBadge status={league.status} />
                    </div>
                  </div>
                  <div className="dashboardLeagueMeta">
                    <span>{league.teamsLabel}</span>
                  </div>
                </button>
              ))
            ) : (
              <div className="dashboardEmptyCard">
                <strong>No active leagues</strong>
                <span>Registration-open and live competitions will appear here first.</span>
              </div>
            )}
          </div>

          <div className="dashboardSectionHeader dashboardSectionHeaderSecondary">
            <h2>Upcoming Matches</h2>
          </div>

          <div className="dashboardMatchList">
            {upcomingMatches.length > 0 ? (
              upcomingMatches.map((match) => (
                <button
                  key={`dashboard-match-${match.id}`}
                  type="button"
                  className="dashboardMatchCard"
                  onClick={() => onOpenMatch?.(match)}
                >
                  <div className="dashboardMatchTeams">
                    <strong>{match.teamA}</strong>
                    <span>vs</span>
                    <strong>{match.teamB}</strong>
                  </div>
                  <div className="dashboardMatchMeta">
                    <span>{match.timeLabel}</span>
                    <StatusBadge status={match.status} label={match.statusLabel} />
                  </div>
                </button>
              ))
            ) : (
              <div className="dashboardEmptyCard">
                <strong>No upcoming matches</strong>
                <span>Scheduled matches and live pairings will show up here.</span>
              </div>
            )}
          </div>
        </div>

        <aside className="dashboardRouteSidebar">
          <div className="dashboardSidePanel">
            <h3>Team Summary</h3>
            {teamSummary ? (
              <button type="button" className="dashboardSummaryCard" onClick={() => onOpenTeam?.()}>
                <strong>{teamSummary.name}</strong>
                <span className="dashboardSummaryRank">{teamSummary.rankLabel}</span>
                <div className="dashboardSummaryMeta">
                  <div>
                    <small>Wins</small>
                    <span>{teamSummary.wins}</span>
                  </div>
                  <div>
                    <small>Losses</small>
                    <span>{teamSummary.losses}</span>
                  </div>
                </div>
              </button>
            ) : (
              <div className="dashboardEmptyCard">
                <strong>No team selected</strong>
                <span>Create or join a team to bring a roster into the command center.</span>
              </div>
            )}
          </div>

          <div className="dashboardSidePanel">
            <div className="dashboardPanelHeader">
              <h3>Notifications</h3>
            </div>
            {notifications.length > 0 ? (
              <div className="dashboardNotificationList">
                {notifications.map((item, index) => (
                  <div key={`dashboard-note-${index}`} className="dashboardNotificationItem">
                    <small>{item.label}</small>
                    <strong>{item.value}</strong>
                  </div>
                ))}
              </div>
            ) : (
              <div className="dashboardEmptyCard">
                <strong>No alerts</strong>
                <span>Your team inbox and competition desk are currently clear.</span>
              </div>
            )}
          </div>
        </aside>
      </div>
    </section>
  );
}

export default DashboardPage;
